import React, { useEffect, useState } from "react";
import { api, errorMessage } from "../../lib/api";
import { Card } from "../../components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../components/ui/table";
import { fmtDate } from "../../lib/constants";
import { toast } from "sonner";

export default function AdminBorrowers() {
  const [list, setList] = useState([]);
  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/borrowers");
        setList(data);
      } catch (e) { toast.error(errorMessage(e)); }
    })();
  }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-semibold tracking-tight">Borrowers</h1>
        <p className="mt-1 text-sm text-slate-400">All borrower accounts.</p>
      </div>
      <Card className="border-slate-800 bg-slate-900">
        <Table>
          <TableHeader>
            <TableRow className="border-slate-800 hover:bg-transparent">
              <TableHead className="text-slate-400">Name</TableHead>
              <TableHead className="text-slate-400">Email</TableHead>
              <TableHead className="text-slate-400">Phone</TableHead>
              <TableHead className="text-slate-400">Applications</TableHead>
              <TableHead className="text-slate-400">Created</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {list.map((b) => (
              <TableRow key={b.user_id} className="border-slate-800 hover:bg-slate-800/40" data-testid={`bwr-row-${b.user_id}`}>
                <TableCell className="text-slate-100 font-medium">{b.name}</TableCell>
                <TableCell className="text-slate-300 text-sm">{b.email}</TableCell>
                <TableCell className="text-slate-300 text-sm">{b.phone || "—"}</TableCell>
                <TableCell className="text-slate-300 tabular-nums">{b.application_count}</TableCell>
                <TableCell className="text-slate-400 text-sm">{fmtDate(b.created_at)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
